// extracted by mini-css-extract-plugin
module.exports = {"InstancesTable":"InstancesTable_InstancesTable__2odqA","Min":"InstancesTable_Min__B7uGV","FilterButton":"InstancesTable_FilterButton__2rnbO"};